import { render, staticRenderFns } from "./QuickEdit.vue?vue&type=template&id=bb53cd18"
import script from "./QuickEdit.vue?vue&type=script&lang=ts"
export * from "./QuickEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb53cd18')) {
      api.createRecord('bb53cd18', component.options)
    } else {
      api.reload('bb53cd18', component.options)
    }
    module.hot.accept("./QuickEdit.vue?vue&type=template&id=bb53cd18", function () {
      api.rerender('bb53cd18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bank/QuickEdit.vue"
export default component.exports